import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {ClickEventHandler, MouseEventHandler} from '../../../../core/src/helpers/react/reactHelpers';
import {ChromelessButton} from '../buttons/chromelessButton';
import {TooltipCoordinator} from '../tooltips/tooltipCoordinator';
import {VisuallyHidden} from '../visuallyHidden/visuallyHidden';
import {FillingOptions, StarWithFilling} from './starWithFilling';

interface StarElementProps {
  label: ReactNode;
  color: FillingOptions;
  isSelected: boolean;
  onClick?: ClickEventHandler;
  onMouseEnter?: MouseEventHandler;
  onMouseLeave?: MouseEventHandler;
  isReadonly?: boolean;
}

const StarWrapperButton = styled(ChromelessButton)`
  padding: 2px;
`;

export const StarElement: FC<StarElementProps> = (props) => (
  <TooltipCoordinator render={() => props.label}>
    <StarWrapperButton
      isDisabled={props.isReadonly}
      onClick={props.onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      <StarWithFilling color={props.color} isSelected={props.isSelected} />
      <VisuallyHidden>{props.label}</VisuallyHidden>
    </StarWrapperButton>
  </TooltipCoordinator>
);
